export function hoverInDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: hoverInDirectiveCtrl,
	};
}

export class hoverInDirectiveCtrl {
	constructor($timeout, $scope, $element, $attrs) {
		'ngInject';
		let inDelay = 1250;
		let outDelay = 333;
		let enterPromise, leavePromise;
		let isIn = false;
		$element
			.on('mouseenter', event => {
				$timeout.cancel(leavePromise);
				enterPromise = $timeout(() => {
					isIn = true;
					event.$element = $element;
					$element.addClass('hover-in');
					$scope.$eval($attrs.shHoverIn, { $event: event });
				}, inDelay);
			})
			.on('mouseleave', event => {
				$timeout.cancel(enterPromise);
				if (!isIn) {
					return;
				}
				leavePromise = $timeout(() => {
					event.$element = $element;
					$element.removeClass('hover-in');
					$scope.$eval($attrs.shHoverOut, { $event: event });
				}, outDelay);
			});
	}
}
